<template>
    <div>
        <v-tabs v-model="sub" density="compact" color="primary" class="mb-1">
            <v-tab value="nearby">Nearby</v-tab>
            <v-tab value="mine">My Equipment</v-tab>
            <v-tab value="gear">Player Gear</v-tab>
        </v-tabs>
        <v-tabs-window v-model="sub">
            <v-tabs-window-item value="nearby">
                <entity-list />
            </v-tabs-window-item>
            <v-tabs-window-item value="mine">
                <equipment />
            </v-tabs-window-item>
            <v-tabs-window-item value="gear">
                <player-gear />
            </v-tabs-window-item>
        </v-tabs-window>
    </div>
</template>

<script lang="ts">
import { defineComponent, ref, watch } from 'vue';
import EntityList from './entityList.vue';
import Equipment from './Equipment.vue';
import PlayerGear from './PlayerGear.vue';

const SUB_KEY = 'funnycharts.entitiesTab';

// Entities tab: nearby entities, the local character's equipment, and the
// last known gear of every player seen.
export default defineComponent({
    components: { EntityList, Equipment, PlayerGear },
    setup() {
        const load = () => { try { return localStorage.getItem(SUB_KEY) || 'nearby'; } catch { return 'nearby'; } };
        const sub = ref(load());
        watch(sub, v => { try { localStorage.setItem(SUB_KEY, v); } catch { /* ignore */ } });
        return { sub };
    },
});
</script>
